<template>
    <VarCard lang="Language">
        <div class="language-body">
            <div class="language-content">
                <div class="language-item" @click="SelectLanguage(v)" v-for="v in localStore.GetLanguageList">
                    <img class="icon" :src="v.Icon" />
                    <span style="white-space: nowrap;">{{ v.Title }}</span>
                    <VarIcon v-show="localStore.GetLocale == v.Code" class="l-action green" name="gouxuan"
                        namespace="icon" />
                </div>
            </div>
        </div>
    </VarCard>
</template>
<script setup lang="tsx">
import { useLanguageStatusStore } from '@/store/LanguageStatusStore';
import { useLocaleStore } from '@/store/locale';

const localStore = useLocaleStore();
const languageStatusStore = useLanguageStatusStore();
/**
 * 选择语言
 * @param v 
 */
function SelectLanguage(v: DB.Language) {
    localStore.SetLocale(v.Code);
    languageStatusStore.show = false;
}
</script>
<style lang="scss" scoped>
.language-body {
    padding: 10px 5px;
    display: flex;
    flex-direction: column;
    max-height: 80%;
    min-width: 180px;
    font-size: 14px;

    .language-content {
        display: flex;
        flex-direction: column;
        overflow-y: auto;

        .language-item {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            width: 100%;

            .icon {
                height: 30px;
                width: 30px;
                border-radius: 50%;
                margin-right: 10px;
            }

            .l-action {
                margin-left: auto;
            }
        }
    }

}
</style>